<template>
  <button type="button" class="Button">
    <slot></slot>
  </button>
</template>

<style scoped>

.Button {

  border-width: 2px;
  border-style: solid;
  border-radius: 6px;

  padding: 0.75rem 1.5rem;

  font-weight: 500;
  font-size: 1rem;
}

.Button[disabled] {
  /*
    These rules are !important in order to override the specific
    appearance rules defined for NextButtons and BackButtons.
  */
  background-color: transparent !important;
  border-color: #E6E8EA !important;
  color: #CED1D5 !important;
}

.Button:focus {
  outline: none;
}
</style>
